<template>
  <div class="Report__Entity">
    <Entity ref="entity" :entity-type="'question'" :isEntityPage="isEntityPage" :showRelations="true"
      :entity-id="questionId" :innerComponent="innerComponent" innerComponentTitle="עריכת שאלה" title="שאלה"
      back-button-text="בנק שאלות" back-button-url="admin/questionsbank" :widgets="widgets" :actions="actions"
      :preview="preview" :read-only="readOnly" :entityReady="entityReady" :activities="[]" @onFormSave="onFormSave"
      @onFormDiscard="onFormDiscard">
      <template #mandatory>
        <div class="Accident__Entity__Details__BaseDetails__Stage">
          <span class="ltr">מספר מזהה לשאלה:</span>
          <span class="
              Accident__Entity__Details__BaseDetails__Stage__Value
              value
              has-text-weight-bold
            ">{{ questionId }}</span>
        </div>
        <div class="Accident__Entity__Details__BaseDetails__Stage">
          <span class="ltr">צפייה בשאלה:</span>
          <span @click="previewQuestion" class="
              Accident__Entity__Details__BaseDetails__Stage__Value
              value
              has-text-weight-bold
              link
            ">קישור</span>
        </div>
        <div class="Accident__Entity__Details__BaseDetails__Stage">
          <span class="ltr">שכפול שאלה:</span>
          <span @click="duplicateQuestion" class="
              Accident__Entity__Details__BaseDetails__Stage__Value
              value
              has-text-weight-bold
              link
            ">לחץ כאן</span>
        </div>
      </template>
    </Entity>
  </div>
</template>

<script>
import Entity from "@/components/Entity.vue";
import QuestionEntityDetails from "@/components/QuestionEntityDetails.vue";
import moment from "moment";
import { mapActions } from "vuex";
import { createHelpers } from "vuex-map-fields";
import AdminService from "@/services/AdminService";
import DialogQuestionPreview from "@/components/DialogQuestionPreview.vue";
import DialogFlipCardPreview from "../components/DialogFlipCardPreview.vue";
import {
  ModalProgrammatic as Modal,
} from "buefy";

const { mapFields } = createHelpers({
  getterType: "lesson/getField",
  mutationType: "lesson/updateField",
});

export default {
  components: {
    Entity,
  },
  props: ["id", "preview", "readOnly"],
  computed: {
    questionId() {
      return this.$route.params.id || this.id;
    },
    isAdmin() {
      return this.$store.state.auth?.user?.claims?.isAdmin === "True";
    },
    widgets() {
      const widgets = [];
      return widgets;
    },
    actions() {
      return null;
    },
    innerComponent() {
      return QuestionEntityDetails;
    },
    ...mapFields(["name", "hasVideos", "hasExercises", "supportingMaterials"]),
  },
  filters: {
    date(value) {
      const date = moment(value, "YYYY-MM-DDThh:mm");
      return date.format("DD/MM/YYYY hh:mm");
    },
  },
  data() {
    return {
      entityReady: false,
      isEntityPage: false
    };
  },
  async created() {
    this.init();
    this.isEntityPage = this.$route.params.id;
  },
  methods: {
    async init(callback) {
      try {
        await this.load({
          id: this.questionId,
        });
        this.entityReady = true;
        if (callback) {
          callback();
        }
      } catch (err) {
        console.log(err);
      }
    },
    previewQuestion() {
      const isFlipCard = this.$store.state.question?.exerciseQuestionTypeId === 6;
      Modal.open({
        component: isFlipCard ? DialogFlipCardPreview  : DialogQuestionPreview,
        customClass: "entity-modal",
        props: {
          id: this.questionId,
          store: this.$store
        },
        canCancel: false,
        trapFocus: true,
      });
    },
    duplicateQuestion() {
      this.$buefy.dialog.confirm({
        title: "שכפול שאלה",
        message: "האם לשכפל שאלה זו?",
        confirmText: "כן",
        cancelText: "לא",
        type: "is-warrent",
        closeOnConfirm: false,
        hasIcon: true,
        onConfirm: (a, instance) => {
          const loadingComponent = this.$buefy.loading.open();
          AdminService.duplicateQuestion(this.questionId).then(() => {
            instance.close();
            loadingComponent.close();
            this.$emit('onSave');
            this.$buefy.toast.open({
              type: "is-success",
              message: "השכפול הצליח...",
              position: "is-top",
              duration: 4000,
            });
          });
        },
      });
    },
    onFormSave({ refresh, closeDialog, model, saving }) {
      saving(true);
      AdminService.updateQuestionInBank(this.questionId, {
        ...this.$store.state.question,
        ...model,
      })
        .then(() => {
          // this.init(refresh);
          this.$emit('onSave');
          this.$buefy.toast.open({
            type: "is-success",
            message: "נשמר בהצלחה!",
            duration: 4000,
          });
        })
        .catch(() => {
          this.$buefy.toast.open({
            type: "is-danger",
            message: "קרתה תקלה, השמירה לא התבצעה!",
            duration: 8000,
          });
          refresh();
        })
        .finally(() => {
          saving(false);
          closeDialog();
        });
    },
    onFormDiscard({ restoreState, closeDialog }) {
      restoreState();
      closeDialog();
    },
    ...mapActions({
      load: "question/loadQuestion",
    }),
  },
};
</script>

<style scoped lang="scss">
.link {
  text-decoration: underline;
  cursor: pointer;
}

.flex-between {
  display: flex;
  justify-content: space-between;

  .Accident__Entity__Details__BaseDetails__Stage__Value {
    padding-right: 0;
  }

  ::v-deep .b-tooltip {
    margin-left: 10px;
  }

  .Pay__Icon {
    border-radius: 3px;
    color: #0091ae;
    position: relative;
    right: -5px;
    font-size: 14px;

    .payment-btn {
      color: white;
      position: absolute;
      left: 20px;
      background-color: #00427e;
      height: 45px;
      margin: 0 10px;
      border: none;
      padding: 10px;
      cursor: pointer;

      &:hover {
        background-color: #0c2949;
      }
    }

    i {
      width: 30px;
      display: inline-block;
      vertical-align: middle;
    }
  }
}
</style>
